"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/Icon.style"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Icon = function Icon(_ref) {
  var _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? true : _ref$isResponsive,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    _ref$group = _ref.group,
    group = _ref$group === void 0 ? 'system' : _ref$group,
    state = _ref.state,
    size = _ref.size,
    numberBadge = _ref.numberBadge,
    name = _ref.name,
    dataAttributes = _ref.dataAttributes,
    id = _ref.id,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var componentName = 'Icon';
  var theme = (0, _styledComponents.useTheme)();
  var checkRuleFields = function checkRuleFields() {
    // If the icon group does not exist then return true
    if (!theme.doesIconGroupExist(group)) return true;
    var iconProperties = theme.getIconProperties(group);
    var errors = new Set();

    // Checks if it has an appearance, and if it does check whether the appearance is valid
    if (iconProperties.appearance) {
      errors.add(!iconProperties.appearance[appearance]);
    }

    // Checks if it has a state, and if it does check whether the state is valid
    if (iconProperties.state && state) {
      errors.add(!iconProperties.state[state]);
    }

    // Checks if there are any errors, if so then return true
    return errors.has(true);
  };
  if (checkRuleFields()) return /*#__PURE__*/_react["default"].createElement(Styled.ErrorPinkBox, null);
  return /*#__PURE__*/_react["default"].createElement(Styled.Icon, _extends({
    id: id,
    state: state,
    "aria-hidden": "true",
    appearance: appearance,
    inverse: inverse,
    size: size,
    isResponsive: isResponsive,
    group: group
  }, dataAttributes, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }), theme.getIcon(name, group, /*#__PURE__*/_react["default"].createElement(Styled.ErrorPinkBox, null)), numberBadge && group === 'system' && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge.number,
    appearance: inverse ? numberBadge.appearance : 'primary',
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'number-badge')
  })));
};
Icon.displayName = "Icon";
var _default = Icon;
exports["default"] = _default;